export class ActionsDispatcher {
    static $inject = ['props'];
    constructor(props) {
        Object.assign(this, props);
    }
}
export class ActionsUpdateAndSaveState extends ActionsDispatcher {
    constructor() {
        super();
    }
}
